
import { AuthenticatedTemplate } from '@azure/msal-react';
import React from 'react';
import { useState, useEffect, MouseEventHandler, PropsWithChildren } from 'react';
import { AuthStatus } from '../authStatus';
import { useIonScreenAuth } from '../Hooks/useIonScreenAuth';



export function TemplateAuthenticated ({children}:PropsWithChildren): React.ReactElement|null {

    const context = useIonScreenAuth();

    if (context.authStatus == AuthStatus.LoggedIn) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>

        );
    }
    return null;

}